import React from "react"

interface ButtonProps {
  children: React.ReactNode
  type?: "button" | "submit" | "reset"
  variant?: "primary" | "secondary" | "ghost" | "danger"
  size?: "sm" | "md" | "lg"
  onClick?: () => void
  disabled?: boolean
  className?: string
  fullWidth?: boolean
}

const VARIANT_CLASSNAME: Record<NonNullable<ButtonProps["variant"]>, string> = {
  primary: "bg-main-purple text-white hover:bg-my-black",
  secondary: "border border-gray-200 bg-gray-100 text-gray-700 hover:bg-gray-200",
  ghost: "bg-transparent text-slate-600 hover:bg-slate-100",
  danger: "bg-red-500 text-white hover:bg-red-600",
}

const SIZE_CLASSNAME: Record<NonNullable<ButtonProps["size"]>, string> = {
  sm: "px-3 py-1.5 text-xs rounded-lg",
  md: "px-4 py-2 text-sm rounded-xl",
  lg: "px-4 py-3 text-sm rounded-xl",
}

const Button: React.FC<ButtonProps> = ({
  children,
  type = "button",
  variant = "primary",
  size = "md",
  onClick,
  disabled = false,
  className = "",
  fullWidth = false,
}) => {
  const widthClassName = fullWidth ? "w-full" : ""

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${VARIANT_CLASSNAME[variant]} ${SIZE_CLASSNAME[size]} ${widthClassName} ${className}`.trim()}
    >
      {children}
    </button>
  )
}

export default Button